// 🏗 [건설] 사고 사례 장표 3종의 수치 정본 — 이치죠 정답지(굴착기 버킷 낙하 v1 · 맥공유
//   `산업안전/모션그래픽-건설안전-20261007/04_적용안/건설안전_회사틀_굴착기/04_제작/index.html` render(t))를
//   1920×1080 기준 px·초 그대로 옮겼다. 화면은 이 값 × (화면 폭 ÷ 1920) 로 그린다(세로는 폭 ÷ 1080).
//   ★정답지와 다른 것 하나★ — 꼬리표 모서리: 정답지는 알약(999px)이지만 전역 디자인 금지(알약형)라 8px
//   (기존 VM 한쪽 패널 꼬리표와 같은 값).
//   ★정답지와 다른 것 둘★ — 꼬리표 글자 26→28px · 출처 줄 24→28px(10-11 장표 본부): 4초 시트 검사 «작은 글씨» 문턱이
//   화면 높이 2.5%(1080 → 27px)라 정답지 값 그대로면 건설 브리핑마다 걸린다(회장님이 1편에서 짚은 «작은 글씨»).
//   색은 가족 색과 무관하게 고정한다(장표 본부 10-09 결정) — 빨강 = 사고, 노랑 = 예방·확인. 색이 곧 뜻이다.

export const CONSTRUCTION_COLORS = Object.freeze({
  red: '#e8392f',
  yellow: '#f6c21b',
  ink: '#141414',
  cream: '#fff7d6',
  /** TBM 바탕(정답지 #tbm) */
  dark: '#1d1d1d',
  /** 체크 칸 안쪽 */
  boxFill: '#fff0b3',
  /** 카드 아래 출처 줄 */
  source: '#6b6252',
  /** 패널 쪽 어둠(정답지 rgba(16,16,16,…)) */
  scrimRgb: [16, 16, 16] as const,
});

/** 오른쪽 패널(사고 개요 · 예방대책) — 정답지 #panel. */
export const CB_PANEL = Object.freeze({
  left: 1180, top: 200, width: 680,
  tagPx: 28, tagPadY: 6, tagPadX: 18, tagRadius: 8,
  titlePx: 58, titleLh: 1.18, titleGapTop: 20, titleGapBottom: 26,
  rowPx: 28, rowLh: 1.35, rowGap: 12, rowLabelW: 150,
  bulPx: 31, bulLh: 1.35, bulGap: 14, bulIndent: 30, bulDot: 11, bulDotTop: 14,
  /** 어둠: 화면 폭 30% 투명 → 58% 0.82 → 끝 0.88 (정답지 #shade) */
  scrim: { clearAt: 30, midAt: 58, mid: 0.82, deep: 0.88 },
});

/** TBM 카드 — 정답지 #tbm·#card·#box. */
export const CB_TBM = Object.freeze({
  stripeH: 22, stripeW: 26,
  cardLeft: 150, cardTop: 150, cardW: 1620, cardH: 610, border: 4, radius: 22, padY: 70, padX: 90,
  titlePx: 68, titleGapTop: 24, titleGapBottom: 34,
  qPx: 42, qLh: 1.3, qGap: 20, qIndent: 38, qDot: 14, qDotTop: 20,
  srcPx: 28, srcBottom: 54,
  boxRight: 120, boxTop: 200, boxSize: 210, boxBorder: 5, boxRadius: 26, checkSize: 110, checkStroke: 12,
});

/** 등장 박자(초) — 정답지 render(t)의 ap(lt, t0, d) 값. 이징 = 3제곱 감속(ease). */
export const CB_TIMING = Object.freeze({
  scrimAt: 0.2, scrimDur: 0.8,
  panelAt: 0.4, panelDur: 0.6, panelShift: 30,
  itemFirst: 1.0, itemGap: 0.55, itemDur: 0.45, itemShift: 16,
  cardAt: 0.1, cardDur: 0.5, cardShift: 30,
  /** TBM 질문: 나레이션 시작 + 3.2초 · 다음은 +2.4초 간격 · 체크는 마지막 질문 + 2.0초(0.6초 동안 그어짐). */
  qFirst: 3.2, qGap: 2.4, qDur: 0.4, checkAfter: 2.0, checkDur: 0.6,
  /** 나레이션 시각을 모를 때 나레이션 시작으로 보는 값(정답지 nstart − start ≈ 0.4~0.8). */
  narrationStart: 0.6,
});

/** 칸에 안 들어가면 글자를 이 비율까지 줄인다 — 자르거나 생략하지 않는다(원문 고정 · 받은 글자 그대로). */
export const CB_MIN_SCALE = 0.55;
/** 자막 막대 위 여유(1920 기준 px). */
export const CB_CAPTION_GAP = 32;
